// Auto generated file, do not manually modify!
// com.hotpads.zcalendar.client.enums.RecurringFrequency

export enum RecurringFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
}

export const RecurringFrequency_values = [RecurringFrequency.DAILY, RecurringFrequency.WEEKLY] as const;
